module.exports = __webpack_public_path__ + "img/tsgxt.cbca9826.png";